"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridOffsetExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/grid/examples/offset.ts';
var GridOffsetExample = /** @class */ (function () {
    function GridOffsetExample() {
    }
    GridOffsetExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { class: 'cui-example-grid', center: false, src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Grid, (0, mithril_1.default)(_1.Col, { span: 2, offset: 10 }, (0, mithril_1.default)('.cui-example-grid-col', 'offset-10'))),
            (0, mithril_1.default)(_1.Grid, (0, mithril_1.default)(_1.Col, { span: 3, offset: 9 }, (0, mithril_1.default)('.cui-example-grid-col', 'offset-9'))),
            (0, mithril_1.default)(_1.Grid, (0, mithril_1.default)(_1.Col, { span: 4, offset: 8 }, (0, mithril_1.default)('.cui-example-grid-col', 'offset-8'))),
            (0, mithril_1.default)(_1.Grid, (0, mithril_1.default)(_1.Col, { span: 5, offset: 7 }, (0, mithril_1.default)('.cui-example-grid-col', 'offset-7'))),
            (0, mithril_1.default)(_1.Grid, (0, mithril_1.default)(_1.Col, { span: 6, offset: 6 }, (0, mithril_1.default)('.cui-example-grid-col', 'offset-6')))
        ]);
    };
    return GridOffsetExample;
}());
exports.GridOffsetExample = GridOffsetExample;
